module.exports = __webpack_public_path__ + "img/two_banner_mobile_bg3.d96e836a.jpg";